import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
//estilos
import "bootstrap/dist/css/bootstrap.css";
import "./assets/scss/theme.scss";

import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: "https://f459339224894144df992e9a87a5394f@o1192043.ingest.us.sentry.io/4510822835879936",
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  tracesSampleRate: 1.0,
  tracePropagationTargets: [
    /^https:\/\/certificado\.sistemasinteegra\.com\.br\//,
  ],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root"),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
